import { useTasks } from "../Tasks";

const Uncomplete = ({ id, complete }) => {
  const { markNotComplete } = useTasks();

  const done = () => {
    markNotComplete(id);
  };

  if (complete === true) {
    return (
      <button className="btn undo-btn" onClick={done}>
        Undo
      </button>
    );
  } else {
    return null;
  }
};

export default Uncomplete;
